<template>
  <FormInputText :id="inputId" type="number" step=".01" :notRequired="notRequired" :disabled="disabled" :placeholder="placeholder" v-model.number="internalValue" />
</template>

<script>

import formInputFieldMixin from './mixins/formInputField';
import formInputTextPropsMixin from './mixins/formInputTextProps';

export default {
  name: 'form-form-input-text',
  mixins: [formInputFieldMixin, formInputTextPropsMixin],
  components: {
    FormInputText: () => import('./FormInputText'),
  },
  computed: {
    internalValue: {
      set (val) {
        this.$emit('input', val);
      },
      get () {
        return parseFloat(this.value);
      },
    },
  },
};

</script>
